const kvs = {
  state: () => ({
    // 档口列表
    printerList: [],
    prePrinterList: [],
    // 菜品列表(全)
    dishList: [],
    //菜品列表（预制）
    preDishList: [],
    // 时段列表
    timeData: [],
    //确认已添加的时段菜品列表，添加时段，需要清空
    addTimeDishData: [],
    //当前编辑的时段索引，添加时段时，需要清空
    editTimeDataIndex: -1,
    // 工位列表
    stationData: [],
    //确认已添加的工位菜品列表，添加工位，需要清空
    addStationDishData: [],
    //当前编辑的时段索引，添加时段时，需要清空
    editStationDataIndex: -1,
    //kvs模式
    stationMode: -1,
    //kds 预制菜品列表
    kdsDishList: [],
    //kds 预制档口
    kdsPrinterList: [],
    //部门信息
    kvsDeptInfo: {},
    //权限信息
    kvsAuthList: [],
    //门店数据
    kvsStoreList: [],
    kvsStoreCode: '',
    kvsStoreName: ''
  }),
  mutations: {
    SET_KVS_STATE (state, payload) {
      const { key, value } = payload
      state[key] = value
    },
  },
  getters: {
    getPrinterList (state) {
      return state.printerList
    },
    getDishList (state) {
      return state.dishList
    },
    getTimeData (state) {
      return state.timeData
    },
    getAddTimeDishData (state) {
      return state.addTimeDishData
    },
    getEditTimeDataIndex (state) {
      return state.editTimeDataIndex
    },
    getStationInfo (state) {
      return state.stationData
    },
    getAddStationDishData (state) {
      return state.addStationDishData
    },
    getEditStationDataIndex (state) {
      return state.editStationDataIndex
    },
    getStationMode (state) {
      return state.stationMode
    },
    getPrePrinterList (state) {
      return state.prePrinterList
    },
    getPreDishList (state) {
      return state.preDishList
    },
    getKdsPrinterList (state) {
      return state.kdsPrinterList
    },
    getKdsDishList (state) {
      return state.kdsDishList
    },
    getKvsDeptInfo (state) {
      return state.kvsDeptInfo
    },
    getKvsAuthList (state) {
      return state.kvsAuthList
    },
    getKvsStoreList (state) {
      return state.kvsStoreList
    },
    getKvsStoreCode(state){
      return state.kvsStoreCode
    },
    getKvsStoreName(state){
      return state.kvsStoreName
    },
  },
  actions: {
    /***
     * 初始化kvs时段配置数据
     */
    initKvsTimeData ({ commit }) {
      commit('SET_KVS_STATE', { key: 'timeData', value: [] })
      // commit('SET_KVS_STATE', { key: 'printerList', value: [] })
      // commit('SET_KVS_STATE', { key: 'dishList', value: [] })
      commit('SET_KVS_STATE', { key: 'addTimeDishData', value: [] })
      commit('SET_KVS_STATE', { key: 'stationData', value: [] })
      commit('SET_KVS_STATE', { key: 'addStationDishData', value: [] })
      commit('SET_KVS_STATE', { key: 'stationMode', value: [] })
      commit('SET_KVS_STATE', { key: 'kvsStoreList', value: [] })
      commit('SET_KVS_STATE', { key: 'kvsStoreCode', value: '' })
      commit('SET_KVS_STATE', { key: 'kvsStoreName', value: '' })
    },
    /***
     * timeData添加时段配置，校验时段名称是否重复，不重复则添加
     */
    timeDataAppend ({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        const { timeData } = state
        const { title } = payload
        const isRepeat = timeData.some((item) => item.title === title)
        const { start_time: newStartTime, end_time: newEndTime } = payload

        if (newStartTime === newEndTime) {
          reject({ code: 1, message: '开始时间不能等于结束时间' })
          return
        }

        if (newStartTime > newEndTime) {
          reject({ code: 1, message: '开始时间不能大于结束时间' })
          return
        }

        const isCross = timeData.some((item) => {
          const { start_time: startTime, end_time: endTime } = item
          return (startTime <= newStartTime && newStartTime <= endTime) || (startTime <= newEndTime && newEndTime <= endTime)
        })

        if (isRepeat) {
          reject({ code: 1, message: '时段名称重复' })
          return
        }
        if (isCross) {
          reject({
            code: 2,
            message: '和其他时段重合，请返回查看其他时段后再进行添加',
          })
          return
        }
        timeData.push(payload)
        commit('SET_KVS_STATE', { key: 'timeData', value: timeData })
        resolve(true)
      })
    },
    timeDataUpdate ({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        const { timeData } = state
        const { title } = payload
        const index = state.editTimeDataIndex
        const { start_time: newStartTime, end_time: newEndTime } = payload

        if (newStartTime === newEndTime) {
          reject({ code: 1, message: '开始时间不能等于结束时间' })
          return
        }
        if (newStartTime > newEndTime) {
          reject({ code: 1, message: '开始时间不能大于结束时间' })
          return
        }

        const isRepeat = timeData.some((item, i) => item.title === title && i !== index)
        //检验时间段交叉
        const isCross = timeData.some((item, i) => {
          const { start_time: startTime, end_time: endTime } = item
          return i !== index && ((startTime <= newStartTime && newStartTime <= endTime) || (startTime <= newEndTime && newEndTime <= endTime))
        })
        if (isRepeat) {
          reject({ code: 1, message: '时段名称重复' })
          return
        }
        if (isCross) {
          reject({
            code: 2,
            message: '和其他时段重合，请返回查看其他时段后再进行添加',
          })
          return
        }
        timeData[index] = payload
        commit('SET_KVS_STATE', { key: 'timeData', value: timeData })
        resolve(true)
      })
    },
  },
}

export default kvs
